import styled from 'styled-components';
import {breakpoints} from 'ui/theme';

export const Center = styled.div`
  max-width: ${(p) => p.theme.maxContentWidth};
  margin: auto;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
    padding: 0 10px;
  }
`;
